import { ethers } from 'ethers'
import * as Admin from '../contracts/admins'

export interface IAdminContract {
  getPools: () => Promise<string[]>
  getParams: (address: string) => Promise<any>
  getPlatformTax: () => Promise<number>
}

const initContract = (
  provider: ethers.BrowserProvider | ethers.JsonRpcProvider,
) => {
  if (provider) {
    return new ethers.Contract(Admin.address, Admin.abi as ethers.InterfaceAbi)
  }
}

const useAdminContract = (
  provider: ethers.BrowserProvider | ethers.JsonRpcProvider,
): IAdminContract => {
  const contract = initContract(provider)

  async function getPools() {
    return await contract?.getTokenSales().catch((err: any) => {
      console.warn(err, 'admin fetch pools')
      return []
    })
  }

  async function getParams(address: string) {
    return await contract?.getParams(address).catch((err: any) => {
      console.warn(err, 'admin get params')
    })
  }

  async function getPlatformTax() {
    try {
      const raw = await contract?.platformTax()
      const tax = Number(raw) / 100
      return tax
    } catch (e) {
      console.error(e)
      return e
    }
  }

  return { getPools, getParams, getPlatformTax }
}

export default useAdminContract
